import { render, staticRenderFns } from "./HistoryPage.vue?vue&type=template&id=6df4dd34&"
import script from "./HistoryPage.vue?vue&type=script&lang=ts&"
export * from "./HistoryPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports